export function duplicateWarningMessage(type: string, nameFile: string = "", dateFile: string = ""): string {
    const map = {
        NAME: `Un archivo con el mismo nombre ${nameFile} ya ha sido procesado en fecha ${dateFile}.`,
        CONTENT: `Un archivo con el mismo contenido con nombre ${nameFile} ya ha sido procesado en fecha ${dateFile}.`,
        DEFAULT: `El archivo ya ha sido subido anteriormente.`
    }
    return map[type] || map.DEFAULT;
}
